import { Container, Row, Col, Button } from "react-bootstrap";
import footerLogo from "../assets/images/footerLogo.png";

const Footer = () => {
  return (
    <div className=" p-md-3 mx-2 mt-md-1 px-3">
      <footer >
        <div className="underline mb-5"></div>
        <Container>
          <Row>
            {/* Left - Logo + Description */}
            <Col md={4} className="mb-4 mb-md-0">
              <div className="d-flex flex-column">
                <img
                  src={footerLogo}
                  alt="Hospease Logo"
                  style={{ width: "200px", marginBottom: "15px" }}
                />
                <p className="footer-text">
                  End-to-end operations for clinics and hospitals —appointments,
                  lab requests/results, e-prescriptions, role-based dashboards,
                  audit logs, and integrations that keep everyone in sync.
                </p>
              </div>
            </Col>
            {/* Middle - Quick Links */}
            <Col xs={4} md={4} className="mb-4 mb-md-0">
              <h6 className="fw-bold text-dark mb-3">Quick Links</h6>
              <ul className="list-unstyled footer-links">
                <li>Pricing</li>
                <li>Features</li>
                <li>Integration</li>
                <li>Security</li>
                <li>Docs</li>
                <li>Careers</li>
                <li>Contact</li>
              </ul>
            </Col>

            {/* Right - Contact */}
            <Col xs={6} md={4}>
              <h6 className="fw-bold text-dark mb-3">Contact</h6>
              <ul className="list-unstyled footer-links">
                <li>sales@hospeasesolution.com</li>
                <li>support@hospeasesolution.com</li>
                <li>Address</li>
              </ul>
            </Col>
          </Row>

          {/* Bottom bar */}
          <Row className="mt-4 pt-3 border-top">
            <Col md={4}>
              <p className="small text-muted mb-1">
                ISO 27001 · ABDM-ready · 99.9% Uptime
              </p>
            </Col>
            <Col md={4} className="text-md-center">
              <p className="small text-muted mb-1">
                © {new Date().getFullYear()} Infosware Private Limited. All rights reserved.
              </p>
            </Col>
            <Col md={4} className="text-md-end">
              <p className="small text-muted mb-1">
                Privacy Policy (with DPDP Grievance Officer), Terms, DPA, SLA
              </p>
            </Col>
          </Row>
        </Container>


      </footer>

    </div>

  );
};

export default Footer;
